// Chakra imports
import { Icon, Text, Flex, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import {
  IsNotEmpty,
  convertDateToFormattedString,
} from "config/functions";

// Custom components
import OrderStep from "components/dataDisplay/OrderStep";
import IconBox from "components/icons/IconBox";
// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdOutlineAccountCircle,
} from "react-icons/md";
export default function YourOrderSteps(props: {
  statusData?: any;
  dataCadastro?: any;
  [x: string]: any;
}) {
  const { statusData, dataCadastro, ...rest } = props;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const completeBg = useColorModeValue(
    "white",
    "linear-gradient(180deg, #1F2A4F 0%, #18224D 50.63%, #111C44 100%)"
  );
  const completeShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "inset 0px 4px 4px rgba(255, 255, 255, 0.2)"
  );
  const incompleteColor = useColorModeValue(
    "secondaryGray.600",
    "whiteAlpha.200"
  );
  const incompleteShadow = useColorModeValue(
    "inset 0px 18px 22px rgba(112, 144, 176, 0.1)",
    "inset 0px 4px 4px #0B1437"
  );
  const lineColor = useColorModeValue("%23BDBDBDFF", "%23BDBDBD1A");

  const refactorStatus = (id: any, dataInclusao?: string, nameCustom?: string) => {
    if (statusData?.length > 0 || IsNotEmpty(dataInclusao)) {
      let itemToShow: any;
      if (IsNotEmpty(dataInclusao)) {
        itemToShow = { dataInclusao, statusGratuidade: { id } };
      } else {
        const groupByStatus = Array.isArray(statusData)
          ? statusData.filter((item: any) => item.statusGratuidade?.id === id)
          : [];

        if (IsNotEmpty(groupByStatus)) {
          if (id === 1) {
            itemToShow = groupByStatus[groupByStatus.length - 1];
          } else {
            itemToShow = groupByStatus.reduce((a: any, b: any) => {
              return new Date(a.dataInclusao) > new Date(b.dataInclusao) ? a : b;
            });
          }
        }
      }

      if (itemToShow) {
        switch (id) {
          case 1:
            return (
              <OrderStep
                key={`status-1-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={"Cadastro Iniciado"}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"done"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdOutlineAccountCircle}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
          case 3:
            return (
              <OrderStep
                key={`status-3-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={nameCustom || "Gratuidade Concedida"}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"done"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCheckCircle}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );

          case 5:
            return (
              <OrderStep
                key={`status-5-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={nameCustom || "Gratuidade Rejeitada/Cancelada"}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"error"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCancel}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
          case 7:
            return (
              <OrderStep
                key={`status-7-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={nameCustom || "Desbloqueado"}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"done"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCheckCircle}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
          case 8:
            return (
              <OrderStep
                key={`status-8-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={nameCustom || "Suspeita de fraude"}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"error"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCancel}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
          default:
            return (
              <OrderStep
                key={`status-${id}-${itemToShow.dataInclusao}`}
                mb={"10px"}
                name={nameCustom || itemToShow.statusGratuidade?.descricao}
                date={convertDateToFormattedString(itemToShow.dataInclusao)}
                status={"done"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCheckCircle}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
        }
      }
    }
  };

  const renderStatus = () => {
    if (IsNotEmpty(statusData) && Array.isArray(statusData)) {
      // Ordena por data decrescente
      const sortedStatus = [...statusData].sort((a: any, b: any) => {
        return (
          new Date(b.dataInclusao).getTime() -
          new Date(a.dataInclusao).getTime()
        );
      });

      // Pega os 3 mais recentes
      const latestStatus = sortedStatus.slice(0, 3);

      return latestStatus.map((item: any) =>
        refactorStatus(
          item.statusGratuidade?.id,
          item.dataInclusao,
          item.statusGratuidade?.descricao
        )
      );
    }

    // Fallback para o comportamento anterior se não for sênior ou se não tiver dados de histórico
    return (
      <>
        {refactorStatus(1)}
        {refactorStatus(2)}
        {refactorStatus(3)}
        {refactorStatus(4)}
        {refactorStatus(5)}
      </>
    );
  };

  return (
    <Flex flexDirection="column" w="100%" pb="20px" {...rest}>
      <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
        Status da Solicitação
      </Text>
      <Flex position="relative" direction="column">
        <Flex
          position="absolute"
          left="32.5px"
          h="100%"
          w="2px"
          bg={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${lineColor}' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`}
          zIndex={1}
        />

        {renderStatus()}
      </Flex>
    </Flex>
  );
}
